import * as React from "react";
import classnames from "classnames";

const styles = require("./styles.module.scss");

interface IProps {
  position?: string;
  theme?: "dark" | "grey";
}

const defaultProps: IProps = {
  position: "after",
  theme: "grey",
};

const Icon: React.SFC<IProps> = ({ position, theme }) => {
  const iconClassNames = classnames(styles.icon, {
    [styles.afterContent]: position === "after",
    [styles.beforeContent]: position === "before",
    [styles.grey]: theme === "grey",
  });

  return <span className={iconClassNames} />;
};

Icon.defaultProps = defaultProps;

export default Icon;
